import React from 'react';

import { Button, ButtonProps, Form } from 'antd';
import { t } from 'i18next';

interface Props {
  isLoading: boolean;
  submiteText?: string;
  props?: ButtonProps;
}

export const SubmiteButton = ({ submiteText, isLoading, ...props }: Props) => (
  <Form.Item>
    <Button type="primary" htmlType="submit" disabled={isLoading} {...props} style={{ width: '100%', marginTop: 10 }}>
      {submiteText ?? t('submite')}
    </Button>
  </Form.Item>
);
